import * as types from "./actionTypes";
import authApi from "../api/signup";
import loginApi from "../api/login"
import { openSuccessSnackbar, openErrorSnackbar } from "./snackbar";

export const signup = (userParams, handleClose) => {
  return (dispatch) => {
    dispatch(userSignupPending());
    return authApi
      .schemeRegister(userParams) // earlier was signup(userParams)
      .then((userResponse) => {
        if (!userResponse.status) {
          dispatch(
            userSignupError(
              "No internet, Please check you internet connection !!",
              false
            )
          );
          dispatch(
            openErrorSnackbar({
              nessage:
                "We're having trouble connecting to our servers at the moment. Please try again in a few minutes.",
            })
          );
          handleClose();
        } else if (userResponse.status === 200) {
          dispatch(userSignupSuccess(userResponse));
          dispatch(openSuccessSnackbar(userResponse));
          handleClose?.();
        } else {
          if(userResponse?.type !== 'otp'){
            handleClose();
          }
          dispatch(
            userSignupError(userResponse.message, userResponse.status === 504)
          );
          dispatch(openErrorSnackbar(userResponse));
        }
      })
      .catch((error) => {
        dispatch(userSignupFailed(error));
      });
  };
};

export const sendSignUpOtp = (payload, successCb, errorCb) => {
  return (dispatch) => {
    dispatch(userSignupOTPPending());
    return loginApi
      .sendOtp(payload)
      .then((userResponse) => {
        dispatch(userSignupOTPDone());
        if (!userResponse.status) {
          errorCb();
          dispatch(openErrorSnackbar(userResponse));
        } else if (userResponse.status === 200) {
          dispatch(openSuccessSnackbar(userResponse));
          successCb();
        } else {
          errorCb();
          dispatch(openErrorSnackbar(userResponse));
        }
      })
      .catch((error) => {
        dispatch(userSignupOTPDone());
        errorCb();
        console.log("Error: ", error);
      });
  };
};

export const updateProfile = (userParams) => {
  return (dispatch) => {
    dispatch(userSignupPending());
    return authApi
      .updateProfile(userParams)
      .then((userResponse) => {
        if (!userResponse.status) {
          dispatch(
            userSignupError(
              "No internet, Please check you internet connection !!",
              false
            )
          );
          dispatch(
            openErrorSnackbar({
              nessage:
                "We're having trouble connecting to our servers at the moment. Please try again in a few minutes.",
            })
          );
        } else if (userResponse.status === 200) {
          dispatch(userSignupSuccess(userResponse));
          dispatch(openSuccessSnackbar(userResponse));
        } else {
          dispatch(
            userSignupError(userResponse.message, userResponse.status === 504)
          );
          dispatch(openErrorSnackbar(userResponse));
        }
      })
      .catch((error) => {
        dispatch(userSignupFailed(error));
      });
  };
};

export const getConsentDetails = (userParams) => {
  return (dispatch) => {
    dispatch(userSignupPending());
    return authApi
      .getConsentDetails(userParams)
      .then((userResponse) => {
        if (!userResponse.status) {
          dispatch(
            userSignupError(
              "No internet, Please check you internet connection !!",
              false
            )
          );
          dispatch(
            openErrorSnackbar({
              nessage:
                "We're having trouble connecting to our servers at the moment. Please try again in a few minutes.",
            })
          );
        } else if (userResponse.status === 200) {
          dispatch(getConsentSuccess(userResponse));
        } else {
          dispatch(
            userSignupError(userResponse.message, userResponse.status === 504)
          );
          dispatch(openErrorSnackbar(userResponse));
        }
      })
      .catch((error) => {
        dispatch(userSignupFailed(error));
      });
  };
};

export const customerLookUp = (payload, unique_id = null, verified = true) => {
  return (dispatch) => {
    dispatch(customerLookUpExistsInitaiated())
    return authApi
      .checkCustomerExists(payload, unique_id)
      .then(response => {
        if (response?.status === 200) {
          verified ? dispatch(openErrorSnackbar(response)) : null;
          dispatch(checkCustomerExistFailure(response));
        }else if(response?.status === 404){
                  dispatch(checkCustomerExistSuccess(response))
        }else{
          dispatch(openErrorSnackbar(response));
          dispatch(checkCustomerExistFailure(response))
        }
      })
      .catch((error) => {
        dispatch(openErrorSnackbar(error));
        dispatch(checkCustomerExistFailure(error));
      });
  };
};

export const getVerifiedCustomer = (mobileNumber, otp) => {
  return (dispatch) => {
    return authApi
      .getVerifiedCustomer(mobileNumber, otp)
      .then(response => {
        if (response?.status === 200) {
          return response;
        }else{
          if(response?.status === 404 && !response?.validOtp){
            dispatch(openErrorSnackbar({message: response?.message}));
          }
          return response;
        }
      })
      .catch((error) => {
        dispatch(openErrorSnackbar(error));
      });
  };
};


export const customerRegisteration = (payload,successCb,errorCb) => {
  return (dispatch) => {
    dispatch(customerRegistertionInitiated())
    return authApi
      .registerCustomer(payload)
      .then(response => {
        if(response?.status === 200){
          dispatch(customerRegistertionSuccess(response))
           if(successCb){
            successCb()
          }
        }else {
          dispatch(openErrorSnackbar(response || { message : "Something went wrong!" }));
          dispatch(customerRegistertionFailed(response));
          if(errorCb){
            errorCb()
          }
        }
      })
      .catch((error) => {
        dispatch(openErrorSnackbar(error || { message : "Something went wrong!" }));
        dispatch(customerRegistertionFailed(error));
        if(errorCb){
            errorCb()
          }
      });
  };
};

export const updateConcent = (payload,successCb,errorCb) =>{
  return (dispatch) => {
    dispatch(customerRegistertionInitiated())
    return authApi
      .updateConcent(payload)
      .then(response => {
        if(response?.status === 200){
          dispatch(customerRegistertionSuccess(response))
           if(successCb){
            successCb()
          }
        }else {
          dispatch(openErrorSnackbar(response || { message : "Something went wrong!" }));
          dispatch(customerRegistertionFailed(response));
          if(errorCb){
            errorCb()
          }
        }
      })
      .catch((error) => {
        dispatch(openErrorSnackbar(error || { message : "Something went wrong!" }));
        dispatch(customerRegistertionFailed(error));
        if(errorCb){
            errorCb()
          }
      });
  };
}

export function userSignupPending() {
  return {
    type: types.SIGNUP_INITIATED,
  };
}

export function userSignupOTPPending() {
  return {
    type: types.SIGNUP_OTP_INITIATED,
  };
}

export function userSignupOTPDone() {
  return {
    type: types.SIGNUP_OTP_DONE,
  };
}


export function userSignupSuccess(user) {
  return {
    type: types.SIGNUP_SUCCESS,
    user: user.message,
  };
}
export function userSignupError(error, signupNotAllowed) {
  return {
    type: types.SIGNUP_INVALID_CREDS,
    error,
    signupNotAllowed,
  };
}
export function userSignupFailed(error) {
  return {
    type: types.SIGNUP_FAILURE,
    error,
  };
}
export function getConsentSuccess(user) {
  return {
    type: types.GET_CONSENT_SUCCESS,
    user: user,
  };
}
export function customerRegistertionSuccess(response) {
  return {
    type: types.CUSTOMER_REGISTERATION_SUCCESS,
    message : response?.message,
  };
}
export function customerRegistertionFailed(error) {
  return {
    type: types.CUSTOMER_REGISTERATION_FAILURE,
    error_message : error?.message
  };
}

export function checkCustomerExistSuccess(response) {
  return {
    type: types.CUSTOMER_LOOKUP_SUCCESS,
    userExists : response?.userExists,
    userConcent: response?.userConcent,
    isOtpEnabled : response?.registrationOtpEnabled,
    message : response?.message
  };
}

export function checkCustomerExistFailure(response) {
  return {
    type: types.CUSTOMER_LOOKUP_FAILURE,
    userExists : false,
    message : response?.message
  };
}

export function customerRegistertionInitiated() {
  return {
    type: types.CUSTOMER_LOOKUP_INITIATED,
  };
}
export function customerLookUpExistsInitaiated() {
  return {
    type: types.CUSTOMER_LOOKUP_INITIATED,
  };
}

export const sendCustomerRegistrationOtp = (payload, successCb, errorCb) => {
  return (dispatch) => {
    return loginApi
      .sendCustomerRegistrationOtp(payload)
      .then((response) => {
        if (!response.status) {
          errorCb();
          dispatch(openErrorSnackbar(response));
        } else if (response.status === 200) {
          dispatch(openSuccessSnackbar(response));
          successCb();
        } else {
          dispatch(openErrorSnackbar(response));
          errorCb();
        }
      })
      .catch((error) => {
        errorCb();
        dispatch(openErrorSnackbar(response));
        console.log("Error: ", error);
      });
  };
};